"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleDimensionHandler = exports.PositionHandler = exports.ClearTransformHandler = exports.StyleHandlers = void 0;

var _parseRGBA = require("../utils/parseRGBA");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var createSizeAttributeHandler = function createSizeAttributeHandler(styleAttribute) {
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'px';
  return function (element, valueFormula, startSnapshot, targetSnapshot, snapshotTrack) {
    var value = valueFormula(parseInt(startSnapshot.style[styleAttribute]), parseInt(targetSnapshot.style[styleAttribute]));
    snapshotTrack.style[styleAttribute] = element.style[styleAttribute] = "".concat(value).concat(suffix);
  };
};

var createColorAttributeHandler = function createColorAttributeHandler(styleAttribute) {
  return function (element, valueFormula, startSnapshot, targetSnapshot, snapshotTrack) {
    try {
      var startColor = (0, _parseRGBA.parseRGBA)(startSnapshot.style[styleAttribute]);
      var targetColor = (0, _parseRGBA.parseRGBA)(targetSnapshot.style[styleAttribute]);
      var calculatedColor = {};

      for (var prop in startColor) {
        calculatedColor[prop] = valueFormula(startColor[prop], targetColor[prop]);
      }

      snapshotTrack.style[styleAttribute] = element.style[styleAttribute] = "rgba(".concat(calculatedColor.r, ",").concat(calculatedColor.g, ",").concat(calculatedColor.b, ",").concat(calculatedColor.a, ")");
    } catch (_unused) {// do nothing because, this is because getComputedStyle is bugged in firefox in a way that some color values are just empty.
      // this way some animation handlers wont work but handlers that comes after them will be called
    }
  };
};

var calculateOpacity = function calculateOpacity(element, valueFormula, startSnapshot, targetSnapshot, snapshotTrack) {
  var value = valueFormula(parseFloat(startSnapshot.style['opacity']), parseFloat(targetSnapshot.style['opacity']));
  snapshotTrack.style['opacity'] = element.style['opacity'] = value;
};

var StyleHandlers = {};
exports.StyleHandlers = StyleHandlers;
['width', 'height', 'fontSize', 'borderWidth'].concat(_toConsumableArray(['Right', 'Left', 'Top', 'Bottom'].map(function (side) {
  return "border".concat(side, "Width");
})), ['padding'], _toConsumableArray(['Right', 'Left', 'Top', 'Bottom'].map(function (side) {
  return "padding".concat(side);
}))).forEach(function (attr) {
  return StyleHandlers[attr] = createSizeAttributeHandler(attr);
});
['color', 'backgroundColor', 'borderColor'].concat(_toConsumableArray(['Right', 'Left', 'Top', 'Bottom'].map(function (side) {
  return "border".concat(side, "Color");
}))).forEach(function (attr) {
  return StyleHandlers[attr] = createColorAttributeHandler(attr);
});
StyleHandlers['opacity'] = calculateOpacity;

var ClearTransformHandler = function ClearTransformHandler(element) {
  return element.style.transform = '';
};

exports.ClearTransformHandler = ClearTransformHandler;

var PositionHandler = function PositionHandler(element, valueFormula, startSnapshot, targetSnapshot, snapshotTrack) {
  var translateX = valueFormula(startSnapshot.rect.left - targetSnapshot.rect.left, 0);
  var translateY = valueFormula(startSnapshot.rect.top - targetSnapshot.rect.top, 0);
  element.style.left = "".concat(targetSnapshot.rect.left, "px");
  element.style.top = "".concat(targetSnapshot.rect.top, "px");
  element.style.transform = [element.style.transform, "translate(".concat(translateX, "px,").concat(translateY, "px)")].join(' ');
  snapshotTrack.rect.left = targetSnapshot.rect.left + translateX;
  snapshotTrack.rect.top = targetSnapshot.rect.top + translateY;
};

exports.PositionHandler = PositionHandler;

var SimpleDimensionHandler = function SimpleDimensionHandler(element, valueFormula, startSnapshot, targetSnapshot, snapshotTrack) {
  var scaleX = valueFormula(startSnapshot.rect.width / targetSnapshot.rect.width, 1);
  var scaleY = valueFormula(startSnapshot.rect.height / targetSnapshot.rect.height, 1);
  element.style.width = "".concat(targetSnapshot.rect.width, "px");
  element.style.height = "".concat(targetSnapshot.rect.height, "px");
  element.style.transform = [element.style.transform, "scale(".concat(scaleX, ",").concat(scaleY, ")")].join(' ');
  snapshotTrack.rect.width = targetSnapshot.rect.width * scaleX;
  snapshotTrack.rect.height = targetSnapshot.rect.height * scaleY;
};

exports.SimpleDimensionHandler = SimpleDimensionHandler;